import { ICON_PATHS, type IconName } from './icons.gen.js';

// Ikon SVG — markup sama dengan icon() v1: <svg class="i {cls}" viewBox="0 0 24 24" aria-hidden="true">…</svg>
export function Icon({ n, cls = '' }: { n: IconName; cls?: string }) {
  return (
    <svg
      className={`i ${cls}`}
      viewBox="0 0 24 24"
      aria-hidden="true"
      // Path statis dari tabel ikon v1 (bukan input pengguna).
      dangerouslySetInnerHTML={{ __html: ICON_PATHS[n] ?? ICON_PATHS.doc }}
    />
  );
}

export type { IconName };

/** HTML ikon sebagai string (untuk penanda peta Leaflet / tempat non-React) — sama dengan icon() v1. */
export const iconHtml = (n: IconName, cls = ''): string =>
  `<svg class="i ${cls}" viewBox="0 0 24 24" aria-hidden="true">${ICON_PATHS[n] ?? ICON_PATHS.doc}</svg>`;
